<template>
  <bita-modal
    id="change-password-modal"
    title="تغییر رمز عبور"
    :modal-sm="true"
    :is-loading="isLoadingModal"
    @close="close"
  >
    <div slot="body">
        <bita-form ref="form">
            <div slot="body">
                <div class="row">
                    <bita-input
                        type="password"
                        ref="oldPassword"
                        name="oldPassword"
                        rules="required"
                        label="رمزعبور فعلی"
                        validation-container-class="col-12"
                        input-class="form-control"
                        v-model="formData.old_password"
                    />
                    <bita-input
                        type="password"
                        ref="oldPassword"
                        name="oldPassword"
                        rules="required"
                        label="رمزعبور جدید"
                        validation-container-class="col-12"
                        input-class="form-control"
                        v-model="formData.password"
                    />
                    <bita-input
                        type="password"
                        ref="oldPassword"
                        name="oldPassword"
                        label="تکرار رمزعبور"
                        rules="required"
                        validation-container-class="col-12"
                        input-class="form-control"
                        v-model="formData.password_confirmation"
                    />
                </div>
            </div>
        </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        type="primary"
        title="تغییر رمز عبور"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="changePassword"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
    data() {
        return {
            isLoadingModal: false,
            formData: {},
        }
    },
    methods: {
        changePassword() {
            this.$refs.form.validate()
                .then( (res) => {
                    if ( res ) {
                        this.isLoadingModal = true;
                        this.$persistClient("patch", "user/change-password", this.formData)
                            .then( (res) => {
                                this.$izitoast("success", "موفق!", res.data.message);
                                this.$toggleModal("#change-password-modal");
                                this.$store.dispatch("logout");
                                this.$router.push("/login");                            
                            })
                            .finally( () => this.isLoadingModal = false );
                    }
                })
        },
        close() {
            this.formData = {};
            this.$refs.form.reset();
        }
    }
}
</script>